import { Link } from '@mui/material';
import React, { useContext } from 'react';
import { UserContext } from '../../common/auth/UserContext';
import { URL_ATTRIBUTES } from '../../common/constants/constants';
import { Icons } from '../../common/icons/Icons';

export const OpenDetailsInNewTabLink = ({ workspaceId }: { workspaceId: string }) => {
    const { application } = useContext(UserContext);

    const params = window.location.search;

    return (
        <Link
            href={`${application.home}/workspace/${workspaceId}/details${params}`}
            target={URL_ATTRIBUTES.target}
            rel={URL_ATTRIBUTES.rel}
        >
            <Icons.NewTabIcon
                sx={{
                    height: 18,
                    width: 18,
                    verticalAlign: 'text-bottom',
                    color: 'currentColor'
                }}
            />
        </Link>
    );
};
